import React from 'react';

export function ReviewSlider({ reviews = [] }) {
  if (!reviews || reviews.length === 0) return null;

  // Duplicate list to achieve continuous loop
  const displayReviews = [...reviews, ...reviews];

  return (
    <div className="w-full overflow-hidden py-4 relative group">
      {/* Left/Right gradient fade for smooth edge appearance */}
      <div className="absolute left-0 top-0 bottom-0 w-16 bg-gradient-to-r from-canvas to-transparent z-10 pointer-events-none" />
      <div className="absolute right-0 top-0 bottom-0 w-16 bg-gradient-to-l from-canvas to-transparent z-10 pointer-events-none" />

      <div className="animate-infinite-scroll flex gap-6">
        {displayReviews.map((rev, idx) => (
          <div
            key={`${rev.id || rev.name}-${idx}`}
            className="w-[300px] sm:w-[360px] md:w-[400px] bg-canvas rounded-2xl p-6 shadow-xs border border-brand-border flex flex-col justify-between shrink-0"
          >
            <div>
              {/* Star Rating */}
              <div className="flex items-center gap-1 text-brand-accent mb-3" aria-label={`${rev.rating || 5} ud af 5 stjerner`}>
                {[...Array(rev.rating || 5)].map((_, i) => (
                  <i key={i} className="fa-solid fa-star text-xs" aria-hidden="true" />
                ))}
              </div>

              {/* Quote */}
              <p className="text-brand-charcoal text-sm sm:text-base font-serif italic leading-relaxed">
                "{rev.quote}"
              </p>
            </div>

            {/* Author Footer */}
            <div className="mt-5 pt-4 border-t border-brand-border flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-full bg-surface border border-brand-border text-brand-charcoal font-bold flex items-center justify-center text-xs">
                  {rev.name?.charAt(0) || 'K'}
                </div>
                <div>
                  <div className="font-semibold text-brand-charcoal text-sm">
                    {rev.name}
                    {rev.age ? `, ${rev.age} år` : ''}
                  </div>
                  {rev.city && (
                    <div className="text-brand-muted text-xs flex items-center gap-1">
                      <i className="fa-regular fa-location-dot text-[10px] text-brand-accent" aria-hidden="true" />
                      <span>{rev.city}</span>
                    </div>
                  )}
                </div>
              </div>
              <span className="text-[10px] uppercase font-bold text-brand-charcoal bg-surface px-2.5 py-1 rounded-full border border-brand-border">
                Verificeret
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
